<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [class]="isShowDetailPage ? 'd-none' : ''"
  [config]="pageConfig"
  (onAdd)="onCreate()"
  (sortObject)="getSortItems($event)"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  [id]="pageId"
>
  <!--------------------------------------- Table Content ---------------------------------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- id -->
        <td>
          <td-value copyToClipboard [value]="item?.id"></td-value>
        </td>

        <!-- amount -->
        <td>
          <td-value
            copyToClipboard
            type="number"
            [value]="item?.amount"
          ></td-value>
        </td>

        <!-- smsCount -->
        <td>
          <td-value
            copyToClipboard
            [value]="item.smsCount"
            type="number"
          ></td-value>
        </td>

        <!-- userName -->
        <td>
          <td-value copyToClipboard [value]="item?.userName"></td-value>
        </td>

        <!-- organizationName -->
        <td>
          <td-value
            copyToClipboard
            type="text"
            [value]="item?.organizationName"
          ></td-value>
        </td>

        <!-- TypePayment -->
        <td
          class="tw-font-medium tw-font-medium tw-text-right tw-pr-[30px] ltr:tw-pl-[30px] tw-text-gray-600"
        >
          <i
            [matTooltip]="
              item?.typePayment | enumToText : TypePaymentsEnumValues
            "
            [paymentTypeStyle]="item?.typePayment"
          ></i>
        </td>

        <!-- isOnlineGeneral -->
        <td>
          <td-value type="boolean" [value]="item?.isOnlineGeneral"></td-value>
        </td>

        <!-- accountInformationBank -->
        <td>
          <td-value
            copyToClipboard
            [value]="
              item?.accountInformationBank | enumToText : TypeBanksEnumValues
            "
          ></td-value>
        </td>

        <!-- account -->
        <td>
          <td-value
            copyToClipboard
            [value]="item.accountInformationAccountNo"
          ></td-value>
        </td>

        <!-- Owner -->
        <td>
          <td-value
            copyToClipboard
            [value]="item.accountInformationOwner"
          ></td-value>
        </td>

        <!-- domainName -->
        <td>
          <td-value copyToClipboard [value]="item?.domainName"></td-value>
        </td>

        <!-- typeStatus -->
        <td>
          <span
            [paymentStatusStyle]="item?.typeStatus"
            [matTooltip]="
              item?.typeStatus | enumToText : TypePaymentStatusEnumValues
            "
          >
            <span class="font-vazir"> </span>
          </span>
        </td>

        <!-- smsCountPerPriceDescription -->
        <td
          [ngClass]="{
            ' tw-cursor-pointer': item?.smsCountPerPriceDescription
          }"
          class="msg-summary tw-text-center"
        >
          <div
            class="tw-flex-center"
            textPopover
            selectorType="id"
            [parentSelector]="pageId"
            [fullText]="item?.smsCountPerPriceDescription"
            [hidePopover]="
              !showParent ||
              pageConfig?.isVisibleHelpPage ||
              pageConfig?.isVisibleAuditPage
            "
          >
            <p
              class="tw-text-gray-500 dark:!tw-text-gray-200 tw-font-normal max-one-row tw-w-[100px] tw-min-w-[100px]"
            >
              {{ item?.smsCountPerPriceDescription | checkValue }}
            </p>
          </div>
        </td>

        <!-- paymentDate -->
        <td>
          <td-value
            type="dateTimeWithSpace"
            [value]="item?.paymentDate"
          ></td-value>
        </td>

        <!-- created -->
        <td>
          <td-value type="dateTimeWithSpace" [value]="item?.created"></td-value>
        </td>

        <!------------------------------- operations -------------------------------->
        <td class="sticky-td">
          <div
            app-menu-btn
            [matMenuTriggerFor]="menu"
            [isShowDotsMenu]="true"
          ></div>
          <mat-menu #menu="matMenu" xPosition="before">
            <ng-container
              *ngIf="
                userSession?.isSuperAdmin() ||
                item?.typeStatus == TypePaymentStatus.Checking
              "
            >
              <!-- confirm button -->
              <div
                app-menu-btn
                icon="mdi mdi-check-bold mdi-20px"
                color="green"
                [title]="pageVocabs + 'confirmPayment'"
                (click)="onConfirm(item.id)"
              ></div>

              <!-- reject button -->
              <div
                app-menu-btn
                icon="mdi mdi-close-thick mdi-20px"
                color="red"
                [title]="pageVocabs + 'rejectPayment'"
                (click)="onReject(item.id)"
              ></div>
            </ng-container>

            <!-- detail button -->
            <div
              app-menu-btn
              icon="mdi mdi-text-box-search-outline mdi-20px"
              color="gray"
              [title]="'common.showDetails' | translate"
              (click)="onShowDetails(item)"
            ></div>

            <!-- image button -->
            <div
              *ngIf="item.isHaveImage"
              app-menu-btn
              icon="mdi mdi-image-outline mdi-20px"
              color="indigo"
              [title]="'common.paymentImage' | translate"
              (click)="onShowImage(item.id)"
            ></div>
          </mat-menu>
        </td>
      </tr>
    </ng-container>

    <tr class="tw-py-2 total-sum" *ngIf="!this.pageConfig.isEmpty">
      <td
        class="tw-pr-[15px] ltr:tw-pl-[15px] tw-text-center !tw-py-3 tw-text-gray-600"
        colspan="2"
      >
        {{ "common.totalSum" | translate }}
      </td>
      <td
        class="tw-pr-[15px] ltr:tw-pl-[15px] tw-text-center tw-text-gray-800 tw-font-medium"
      >
        {{ totalSum | numberSeparator }}
      </td>
      <td
        class="tw-pr-[15px] ltr:tw-pl-[15px] tw-text-center tw-text-gray-800 tw-font-medium"
      >
        {{ totalSmsCount | numberSeparator }}
      </td>
      <td
        class="tw-pr-[15px] ltr:tw-pl-[15px] tw-text-center"
        colspan="12"
      ></td>
    </tr>
  </ng-container>
</app-page-template>

<!------------------------------------- Audit -------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    [methodName]="auditApiMethodName"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>

<!------------------------------------ Detail --------------------------------->
<app-base-payment-details
  *ngIf="isShowDetailPage"
  [model]="detailPageModel"
  (closePage)="
    isShowDetailPage = false; showParent = true; getParentQueryString()
  "
  [TypeBanksEnumValues]="TypeBanksEnumValues"
  [TypePaymentStatusEnumValues]="TypePaymentStatusEnumValues"
  [TypePaymentsEnumValues]="TypePaymentsEnumValues"
>
</app-base-payment-details>

<!------------------------------------- help ------------------------------------------>
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="
      pageId == 'payments-for-confirm'
        ? 'paymentsForConfirm'
        : 'resellerPaymentsForConfirm'
    "
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
